import { useState } from 'react';
import { IconName, Popover, Toggle } from '@ets/design-system';
import { SplitToggle } from '_common/components';

import { useSelector } from '_common/hooks';
import EditorManager from 'Editor/services/EditorManager';
import { selectIsPageLayout, selectReadOnlyMode } from 'Editor/redux/EditorStatusSlice';

import styles from './Alignment.module.scss';

const Alignment = () => {
  const isReadOnlyMode = useSelector(selectReadOnlyMode);
  const isPageLayout = useSelector(selectIsPageLayout);
  const isImageSelected = useSelector((state) => state.editor.status.selection.IMAGE);
  const selectedStyle = useSelector((state) => state.editor.toolbar.alignment);
  const [isOpen, setIsOpen] = useState(false);

  // TODO: Set style type given by RT once provided
  const handleJustifyContent = (style: any) => {
    EditorManager.getInstance().alignCurrentSelection({ style });
  };

  const getToggledIcon = (): IconName => {
    switch (selectedStyle) {
      case 'c':
        return 'align-center';
      case 'r':
        return 'align-right';
      case 'j':
        return 'align-justify';
      default:
        return 'align-left';
    }
  };

  return (
    <Popover.Root placement="bottom-start" open={isOpen} onOpenChange={() => setIsOpen(!isOpen)}>
      <Popover.Trigger>
        <SplitToggle
          isToggled={isOpen}
          icon={getToggledIcon()}
          iconColor="neutral"
          onClick={() => handleJustifyContent(selectedStyle)}
          isOpen={isOpen}
          disabled={isReadOnlyMode || isPageLayout}
          testId="alignment"
          onPopperClick={() => setIsOpen(!isOpen)}
        />
      </Popover.Trigger>
      <Popover.Content testId="alignment" style={{ minWidth: '6.25rem' }}>
        <div className={styles.popoverRoot}>
          <Toggle
            size="m"
            variant="link"
            iconProps={{ icon: 'align-left' }}
            isToggled={selectedStyle === 'l'}
            onClick={() => handleJustifyContent('left')}
            testId="alignment-left"
          />
          <Toggle
            size="m"
            variant="link"
            iconProps={{ icon: 'align-center' }}
            isToggled={selectedStyle === 'c'}
            onClick={() => handleJustifyContent('center')}
            testId="alignment-center"
          />
          <Toggle
            size="m"
            variant="link"
            iconProps={{ icon: 'align-right' }}
            isToggled={selectedStyle === 'r'}
            onClick={() => handleJustifyContent('right')}
            testId="alignment-right"
          />
          {!isImageSelected && (
            <Toggle
              size="m"
              variant="link"
              iconProps={{ icon: 'align-justify' }}
              isToggled={selectedStyle === 'j'}
              onClick={() => handleJustifyContent('justify')}
              testId="alignment-justify"
            />
          )}
        </div>
      </Popover.Content>
    </Popover.Root>
  );
};

export default Alignment;
